export default Object.freeze({
    OFFLINE  : 'offline', // offline
    UNKNOWN  : 'unknown', // has not been checked yet
    HEALTHY  : 'healthy', // all good
    DEGRADED  : 'degraded', // some non vital issues
    CRITICAL  : 'critical', // something went terribly wrong
    DEPLOYING : 'deploying',
    SHUTTING_DOWN : 'shutting_down',
})
